// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "main.module." + {"180":"3b9f45fb254636540ac2","373":"e61684499a9b813e578a"}[chunkId] + ".js";
};